import React, { useEffect, useMemo, useState } from "react";
import ComboboxAutocomplete from "./combobox_autocomplete";
import { getWorkingHoursCompound } from "../services/api_working_hours";

export default function WorkingHoursCompoundSelect({
  token,
  permission = "payrolls",
  sourceOu = null,          // può essere OGGETTO ou oppure ID oppure null
  value = null,
  onChange,
  placeholder = "Cerca e seleziona un modello turno...",
  disabled = false,
  zIndex = "z-[80]",

  // opzionale: override del rendering
  renderOption,
}) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  // supporta: sourceOu = {id} oppure number/string id oppure null
  const ouId = sourceOu?.id ?? sourceOu ?? null;

  // reset selezione quando cambia OU sorgente
  useEffect(() => {
    onChange?.(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ouId]);

  useEffect(() => {
    if (!token) return;

    const controller = new AbortController();
    const { signal } = controller;

    (async () => {
      try {
        setLoading(true);
        const res = await getWorkingHoursCompound(token, ouId, permission, signal);
        setItems(Array.isArray(res) ? res : []);
      } catch (e) {
        if (e?.name !== "CanceledError" && e?.name !== "AbortError") {
          console.error("getWorkingHoursCompound error:", e);
        }
        setItems([]);
      } finally {
        setLoading(false);
      }
    })();

    return () => controller.abort();
  }, [token, permission, ouId]);

  const options = useMemo(() => {
    return (items || []).map((wh) => {
      const ouLabel = wh?.ou?.name || wh?.ou_name || wh?.unit?.name || "Generico";

      return {
        ...wh,
        name: wh?.name || "—",
        __rawName: wh?.name || "—",
        __ouLabel: ouLabel,
      };
    });
  }, [items]);

  // Default: nome a sinistra, badge OU a destra
  const defaultRender = (shift) => (
    <div className="flex items-center gap-3 w-full">
      <span className="min-w-0 flex-1 text-sm text-gray-700 truncate">
        {shift.__rawName || shift.name || "—"}
      </span>

      <span className="ml-auto shrink-0 max-w-[40%] truncate rounded-full bg-indigo-50 px-2.5 py-0.5 text-[11px] font-semibold text-indigo-700 border border-indigo-300">
        {shift.__ouLabel || "Generico"}
      </span>
    </div>
  );

  return (
    <div className="w-full border border-gray-200 rounded-lg bg-white shadow-sm">
      <ComboboxAutocomplete
        options={options}
        value={value}
        onChange={(opt) => onChange?.(opt || null)}
        placeholder={loading ? "Caricamento..." : placeholder}
        bgActiveColor="bg-indigo-50"
        textActiveColor="text-gray-900"
        positionOptions="absolute"
        zIndex={zIndex}
        borderClass="border-gray-200 rounded-lg"
        borderInput={disabled ? "opacity-60 pointer-events-none" : ""}

        // input: mostra solo il nome del turno
        displayValue={(el) => (el?.__rawName ? el.__rawName : el?.name || "")}

        // render default (override se passato dal parent)
        renderOption={renderOption || defaultRender}
      />
    </div>
  );
}